import { IfAuthorized } from '@tbitop/authorization';
import { MobilePage } from '@tbitop/mobile-app';
import { useQueryParamState } from '@tbitop/routing';
import { ButtonActionOption, ButtonActionOptionLink, ButtonActionWithMenu, IconButton, LoadingSpinner } from '@tbitop/ui';
import { ChatCircleDots, NotePencil, Plus } from 'phosphor-react';
import { environment } from '../environments/environment';
import { useObjektAufgabenStatistik, useObjekte } from '../infrastructure/graphql';
import { Aufgabenstatistik, ObjektList } from '../ui/controller';
import type { ObjektFilters, ObjektSorting } from '../ui/controller/objekt-filter';
import { Objektfilter } from '../ui/controller/objekt-filter';

const defaultFilterValues: Readonly<ObjektFilters> = {};
const defaultSorting: ObjektSorting = [];

const aufgabentypen: Record<string, string> = {
  Umfrage: 'Umfrage',
  Aktion: 'Aktion',
  Sortimentsluecke: 'Sortimentslücke',
  Kombinationsluecke: 'Kombinationslücke',
  Individuell: 'Individuell',
  IndividuellKarte: 'Individuell (Karte)',
};

export const Objekte = () => {
  const { objektAufgabenStatistik } = useObjektAufgabenStatistik();
  const [filterValues, setFilterValues] = useQueryParamState(
    'filter',
    defaultFilterValues,
  );

  const [sorting, setSorting] = useQueryParamState<ObjektSorting>(
    'sort',
    defaultSorting,
  );

  const { pagination, pageLoading, objekte, loading, refresh } =
    useObjekte(sorting, filterValues);

  return (
    <MobilePage title="Objekte mit Aufgaben" onPullToRefresh={() => refresh()}>
      <div className="sticky top-0 z-50 bg-tds-color-organizer-90 pb-300">
        <Aufgabenstatistik
          className="ml-200 mb-100"
          objektAufgabenstatistik={objektAufgabenStatistik}
        />
        <Objektfilter
          filterValues={filterValues}
          onFilterChange={setFilterValues}
          sorting={sorting}
          aufgabentypen={aufgabentypen}
          onSortChange={setSorting} />
      </div>

      {loading || pageLoading ? (
        <div className="flex items-center justify-center my-48">
          <LoadingSpinner />
        </div>
      ) : null}
      <ObjektList
        objekte={loading ? [] : objekte}
        pagination={pagination}
        pageLoading={pageLoading} />

      <div className="fixed z-50 bottom-4 right-4">
        <ButtonActionWithMenu ButtonComponent={<IconButton iconOnly icon={Plus} variant="primary" label=""/>}>
          <IfAuthorized config={{ resourceName: 'vert-api', requiredRoles: ['AufgabenErstellerMobile'] }}>
            <ButtonActionOptionLink href="/individuelle-aufgabe">
              <div className="flex gap-5">
                <NotePencil/> Individuelle Aufgabe
              </div>
            </ButtonActionOptionLink>
          </IfAuthorized>
          <ButtonActionOptionLink href="/aktionsaufgabe">
            <div className="flex gap-5">
              <Plus/> Aktionsaufgabe
            </div>
          </ButtonActionOptionLink>
          <IfAuthorized config={{ resourceName: 'vert-api', requiredRoles: ['Vertriebsfluesterer'] }}>
            <a href={`${environment.baseUrl}sales-whisperer/`}>
              <ButtonActionOption role="none">
                <div className="flex gap-5">
                  <ChatCircleDots/> Vertriebsflüsterer
                </div>
              </ButtonActionOption>
            </a>
          </IfAuthorized>
        </ButtonActionWithMenu>
      </div>
    </MobilePage>
  );
};
